import React, {useEffect, useState} from 'react';
import Axios from 'axios';
import { Modal } from 'react-bootstrap';
import '../App.css';
import { useNavigate } from "react-router-dom";
import { Alert } from 'react-bootstrap';

function Grillasausuarios (props){
    const navigate = useNavigate();

    const [casinos, setCasinos] = useState([]);
    const [perfiles, setPerfiles] = useState([]);
    const [datos, setDatos] = useState([]);
    const [searchmail, setSearchmail] = useState();
    const [changecasino, setChangeCasino] = useState('0');
    const [changeperfil, setChangePerfil] = useState('0');
    const [idsaldo, setIdsaldo] = useState();
    const [cantidadtickets, setCantidadTickets] = useState('');
    const [valorTicket, setValorTicket] = useState();


    const [show, setShow] = useState(false);

  

    const [tituloAlert, setTituloAlert] = useState('')
    const [textoAlert, setTextoAlert] = useState('')
    const [claseAlert, setClaseAlert] = useState('')
    const [alert, setAlert] = useState(false);

    const [tituloAlert1, setTituloAlert1] = useState('')
    const [textoAlert1, setTextoAlert1] = useState('')
    const [claseAlert1, setClaseAlert1] = useState('')
    const [alert1, setAlert1] = useState(false);

    const [classWaitProcess, setClassWaitProcess] = useState('waitProcess')    

    let statuscall = '' 
    

    const perfilesList = perfiles.map((item, i) => 
    <option key={i} value={item.id}>{item.nombre}</option>);
    
    const casinosList = casinos.map((item, i) =>
    <option key={i} value={item.id}>{item.nombre}</option>);


    const dataList = datos.map((item, i) => 
    <div key={i} className='row'>
         <div className='saLineGrid col col-xl-3 col-lg-3 col-md-3 col-sm-3'>{item.mail}</div>
         <div className='saLineGrid col col-xl-3 col-lg-3 col-md-0 col-sm-0'>{item.nombre} {item.apellido}</div>
         <div className='saLineGrid col col-xl-3 col-lg-3 col-md-0 col-sm-0'>{item.rut}</div>
         <div className='saLineGrid col col-xl-3 col-lg-3 col-md-3 col-sm-3'><button onClick={() => agregarSaldo(item)} className='btn btn-adminsaprivateRegular'>Agrega Saldo</button></div>
    </div>);

    useEffect(() => {
        let idperfilstr = window.localStorage.getItem('MY_APP_STATE_PROF_ID').replace('"', '')
        let idperfil = idperfilstr.replace('"', '')

        Axios.get(process.env.REACT_APP_DATAUSER, {
            params: {
                id_perfil: idperfil
            }, 
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        }).then((response) => {
            setCasinos(response.data.casinos)
            setPerfiles(response.data.perfiles)
        }).catch(error => {
            return error     
        });
    }, []);





    const handlerChangeCasino= (e) => {
        setChangeCasino(e.target.value)
    }

    const handlerChangePerfil= (e) => {
        setChangePerfil(e.target.value)
    }    

    const handlerChangeMail= (e) => {
        setSearchmail(e.target.value)
    }    

    const handelSearch = () => {
        setDatos([]);
        Axios.get(process.env.REACT_APP_URLUSERSEARCH, {
            params: {
                mail: searchmail,
                casino_id: changecasino,
                perfil_id: changeperfil
            }, 
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        }).then((response) => {
            setDatos(response.data.usuarios)
        }).catch(error => {
            return error     
        });
    }

    const agregarSaldo = (item) => {
        setCantidadTickets()
        setValorTicket(item.value_ticket)
        setIdsaldo(item.mail)
        handleShow()
    }

    const handleCantidad = async (e) =>{
        setCantidadTickets(e.target.value)
    }

    const crearConsumo = () =>{
        if(cantidadtickets != 'undefined' && cantidadtickets !=  null && cantidadtickets != '')
        {
            setTituloAlert('Confirmación')
            setTextoAlert('Esta ingresando' + ' ' + cantidadtickets + ' tickets a favor del usuario ' + idsaldo + '. Desea confirmar el ingreso?')
            setClaseAlert('warning')
            setAlert(true)
        }
        else
        {
            setTituloAlert1('Creacion de saldos')
            setTextoAlert1('Debe agregar un cantidad de tickets')
            setClaseAlert1('danger alertFlotante opacity-100')
            setAlert1(true)
            setTimeout(() => {    
                setAlert1(false)
            }, 3000)            
        }

    }
    
    const confirmaIngresoSaldo = async () =>{
        setAlert(false)

        const data = {   
            mail: idsaldo,    
            cantidad: cantidadtickets,
            valor_ticket: valorTicket
        }

        const ingresaSaldoTickets = await Axios.post(process.env.REACT_APP_CREATESALDO, data, {
            timeout: process.env.REACT_APP_TIMEOUT,
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        }).then(res => statuscall = res).catch(err => statuscall = err.response)

        if(statuscall.status == 200)
        {
            if(statuscall.data.MessageCode == '0')
            {
                setClassWaitProcess('waitProcess')
                setTituloAlert1('Creacion de saldos')
                setTextoAlert1('Saldo creado con exito')
                setClaseAlert1('success alertFlotante opacity-100')
                setAlert1(true)
                setTimeout(() => {    
                    setAlert1(false)
                    handleClose()
                }, 3000)
            }
            else
            {
                setClassWaitProcess('waitProcess')
                setTituloAlert1('Creacion de saldos')
                setTextoAlert1(statuscall.data.Message)
                setClaseAlert1('danger alertFlotante opacity-100')
                setAlert1(true)
                setTimeout(() => {
                    setAlert1(false)
                }, 3500)
            }                            
        }
        else
        {
            setClassWaitProcess('waitProcess')
            setTituloAlert1('Creacion de saldos')
            setTextoAlert1('Servidor no responde. Intentelo mas tarde')
            setClaseAlert1('danger alertFlotante opacity-100')
            setAlert1(true)
            setTimeout(() => {
                setAlert1(false)
            }, 3500)             
        }

    }

    const handleShow = () => setShow(true)
    const handleClose = () => {
        setIdsaldo('')
        setShow(false)
    }

    return(
    <div className='container'>
        <div className='col col-xl-12 col-lg-12 col-md-12 col-sm-12'>
                        
            <div className='row sabackComponent'>
                <div className='col col-xl-12 col-lg-12 col-md-12 col-sm-12'>
                    <h4>Asignacion de saldo de tickets</h4>
                </div> 
            </div>

            <div className='row sabackComponent'>

                <div className='col col-xl-3 col-lg-3 col-md-6 col-sm-12'>
                    <select className='safiltercontrols' onChange={handlerChangeCasino}>
                        <option value='0'>Seleccione Casino</option>
                        {casinosList}
                    </select>
                </div>

                <div className='col col-xl-3 col-lg-3 col-md-6 col-sm-12'>
                    <select className='safiltercontrols' onChange={handlerChangePerfil}>
                        <option value='0'>Seleccione Tipo Usuario</option>
                        {perfilesList}
                    </select>
                </div>                            

                <div className='col col-xl-3 col-lg-3 col-md-6 col-sm-12'>
                    <input className='safiltercontrols' type='text' value={searchmail} onChange={handlerChangeMail} placeholder='Ingrese mail'></input>
                </div>

                <div className='col col-xl-3 col-lg-3 col-md-6 col-sm-12'>
                    <button className='btn btn-adminsaprivate' onClick={handelSearch}>Buscar</button>
                </div>

            </div> 

            <div className='row sabackComponent'>
                    <div className='row saTitulosGrid'>
                        <div className='col col-xl-3 col-lg-3 col-md-3 col-sm-3'>Mail</div>
                        <div className='col col-xl-3 col-lg-3 col-md-0 col-sm-0'>Nombre</div>
                        <div className='col col-xl-3 col-lg-3 col-md-0 col-sm-0'>Rut</div>
                        <div className='col col-xl-3 col-lg-3 col-md-3 col-sm-3'>Controles</div>
                    </div> 
                    <div className='row saContainerGrid'>               
                        {dataList}
                    </div>
            </div>

        </div>        

        <Modal show={show} onHide={handleClose} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Crear saldo de tickets a favor</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className={classWaitProcess}>
                    <div className='loaderS divAbsolute'>
                    </div>
                </div>

                <div className='row divAbsolute'>
                    <div className='col col-lg-12'>
                        {alert
                        ?<Alert variant={claseAlert} onClose={() => setAlert(false)} dismissible fade show>
                            <Alert.Heading>{tituloAlert}</Alert.Heading>
                                <p>
                                    {textoAlert}
                                </p>
                                <hr></hr>
                                <p class="mb-0"><button className='btn btn-adminsaprivateRegular' onClick={confirmaIngresoSaldo}>Confirmar</button><button className='btn btn-adminsaprivateRegular' onClick={() => setAlert(false)}>Rechazar</button></p>    
                        </Alert>
                        :''
                        }

                        {alert1
                        ?<Alert variant={claseAlert1} onClose={() => setAlert1(false)} dismissible fade show>
                        <Alert.Heading>{tituloAlert1}</Alert.Heading>
                            <p>
                                {textoAlert1}
                            </p>
                        </Alert>
                        :''                            
                        }
                    </div>
                </div>

                <div className='row'>
                    <div className='col col-lg-4'>
                        Usuario                                                                    
                    </div>
                    <div className='col col-lg-4'>
                        <input type='text' value={idsaldo}></input>
                    </div>
                </div>

                <div className='row'>
                    <div className='col col-lg-4'>
                        Cantidad de tickets a favor                                                                    
                    </div>
                    <div className='col col-lg-4'>
                        <input type='text' onChange={handleCantidad} onKeyPress={(event) => {
                                        if (!/[0-9]/.test(event.key)) {
                                            event.preventDefault();
                                        }
                                    }
                                } value={cantidadtickets} ></input> 
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className='btn btn-adminsaprivateRegular' onClick={handleClose}>
                    Cerrar
                </button>
                <button className='btn btn-adminsaprivateRegular' onClick={crearConsumo} >
                    Crear
                </button>
            </Modal.Footer>
        </Modal>    


    </div>    
    )
}
export default Grillasausuarios